import '@uiw/react-md-editor/markdown-editor.css';
import MDEditor, { commands } from '@uiw/react-md-editor';
import ReactMarkdown from 'react-markdown';

interface Props {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  minHeight?: number;
  readOnly?: boolean;
}

export default function RichTextEditor({ value, onChange, placeholder, minHeight = 150, readOnly = false }: Props) {
  if (readOnly) {
    return <MarkdownDisplay content={value} />;
  }

  return (
    <div data-color-mode="light">
      <MDEditor
        value={value}
        onChange={(val) => onChange(val || '')}
        height={minHeight}
        preview="edit"
        hideToolbar={false}
        visibleDragbar={false}
        commands={[
            commands.bold,
            commands.italic,
            commands.divider,
            commands.unorderedListCommand,
            commands.orderedListCommand,
          ]}
        extraCommands={[]}  
      />
    </div>
  );
}

export function MarkdownDisplay({ content }: { content: string }) {
  if (!content) return null;
  return (
    <div className="markdown-content">
      <ReactMarkdown
        allowedElements={['p', 'strong', 'em', 'ul', 'ol', 'li', 'a', 'br', 'code', 'pre']}
        components={{
          ul: ({ node, ...props }) => <ul style={{ listStyleType: 'disc', paddingLeft: '1.5rem', marginBottom: '0.5rem' }} {...props} />,
          ol: ({ node, ...props }) => <ol style={{ listStyleType: 'decimal', paddingLeft: '1.5rem', marginBottom: '0.5rem' }} {...props} />,
          li: ({ node, ...props }) => <li style={{ marginBottom: '0.25rem' }} {...props} />,
          a: ({ node, ...props }) => {
            const href = (props.href || '').trim().toLowerCase();
            const isSafe = href.startsWith('http://') || href.startsWith('https://') || href.startsWith('mailto:');
            return isSafe
              ? <a {...props} target="_blank" rel="noopener noreferrer nofollow" />
              : <span>{props.children}</span>;
          },
          img: () => null,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}

